import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref } from 'vue'
import Modal from './Modal.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const safetyModal = ref<InstanceType<typeof Modal> | null>(null)

async function show() {
  safetyModal.value?.show()
}

expose({
  show,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "safetyModal",
    ref: safetyModal,
    class: "modal-safety",
    title: _ctx.$t('safetyModal.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "safety-content",
        innerHTML: _ctx.$t('safetyModal.text')
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})